import { render, staticRenderFns } from "./RegrasAba.vue?vue&type=template&id=f3d647aa&scoped=true"
import script from "./RegrasAba.vue?vue&type=script&lang=js"
export * from "./RegrasAba.vue?vue&type=script&lang=js"
import style0 from "@/components/regras/regras-listagem.css?vue&type=style&index=0&id=f3d647aa&prod&scoped=true&lang=css&external"
import style1 from "./RegrasAba.vue?vue&type=style&index=1&id=f3d647aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d647aa",
  null
  
)

export default component.exports